import { Icon } from "../ui/Icon.jsx";

function Feature({ icon, title, desc }) {
  return (
    <article className="card feature" data-reveal>
      <div className="featureTop">
        <div className="featureIcon" aria-hidden="true">
          <Icon name={icon} />
        </div>
        <h3 className="h3">{title}</h3>
      </div>
      <p className="muted">{desc}</p>
    </article>
  );
}

export function Product() {
  return (
    <section className="section" id="product">
      <div className="container">
        <div className="sectionHead" data-reveal>
          <h2 className="h2">Сервис, которому верят</h2>
          <p className="muted">
          Более 2000+ клиентов
          уже доверили нам защиту интеллектуальной собственности
          </p>
        </div>

        <div className="grid3">
          <Feature
            icon="shield"
            title="Доказательность"
            desc="Фиксация факта нарушения авторских прав и подготовка доказательной базы."
          />
          <Feature
            icon="bolt"
            title="Открытость"
            desc="Подробные отчеты и полная статистика по всем выявленным нарушениям и полученным за них компенсациям."
          />
          <Feature
            icon="spark"
            title="Опыт"
            desc="Большая судебная практика по защите авторских прав и высокий процент успешных дел."
          />
        </div>
      </div>
    </section>
  );
}

